var filter = {
    init: function() {
        var self = this;

		var noUiSliderFlatSize = document.querySelector( '.flat-size' );

		if( noUiSliderFlatSize ) {
			var noUiSliderSnapValues = [
				document.querySelector('.flat-size__value-low'),
				document.querySelector('.flat-size__value-high')
			];

			var min = parseFloat( noUiSliderFlatSize.getAttribute( 'data-min' ) );
			var max = parseFloat( noUiSliderFlatSize.getAttribute( 'data-max' ) );

			noUiSlider.create( noUiSliderFlatSize, {
				start: [ min, max ],
				connect: true,
				range: {
					'min': min,
					'max': max
				}
			});

			noUiSliderFlatSize.noUiSlider.on('update', function (values, handle) {
				var dataAttr = ( handle == 1 ) ? 'max' : 'min';

				noUiSliderSnapValues[ handle ].setAttribute( `data-${dataAttr}`, values[ handle ] );
				noUiSliderSnapValues[ handle ].innerHTML = values[ handle ] + ' m<sup>2</sup>';

				self.updateFilterLists();
			});
		}

		jQuery( document ).on( 'click', '.filters-item__options input', function(){
			self.updateFilterLists();
		});

		jQuery( document ).on( 'click', 'tr[data-link]', function(){
			window.location.href = jQuery( this ).attr( 'data-link' );
		});
	},

	updateFilterLists: function() {
		jQuery( 'tr[data-floor]' ).removeClass( 'hidden' );

		var flatSizeMin 	= parseInt( jQuery( '.flat-size__value-low' ).attr( 'data-min' ) );
		var flatSizeMax 	= parseInt(  jQuery( '.flat-size__value-high' ).attr( 'data-max' ) );
		var flatSizeType 	= jQuery( 'input[name="flat-size"]:checked' ).val();
		var floor 			= jQuery( 'input[name="floor"]:checked' ).val();

		var availability	= jQuery( 'input[name="availability"]:checked' ).val();
		availability		= ( availability == undefined ) ? false : true;

		jQuery( 'tr[data-floor]' ).each( function(){
			var willShow = true;
			var flatSize = parseInt( jQuery( this ).attr( 'data-size' ) );

			if( flatSize < flatSizeMin || flatSize > flatSizeMax ) {
				willShow = false;
			}

			if( flatSizeType != jQuery( this ).attr( 'data-flat-size' ) && flatSizeType != 'all' ) {
				willShow = false;
			}

			if( floor != jQuery( this ).attr( 'data-floor' ) && floor != 'all' ) {
				willShow = false;
			}

			if( availability && jQuery( this ).attr( 'data-availability' ) != 1 ) {
				willShow = false;
			}

			if( ! willShow ) {
				jQuery( this ).addClass( 'hidden' );
			}
		});

		jQuery( 'thead' ).each( function (){
			var jHead = jQuery(this);
			var hasContent = false;
			var jBody = jHead.next();
			jBody.children('[data-floor]').each( function (){
				var jRow = jQuery(this);
				hasContent = hasContent || !jRow.hasClass('hidden');
			});
			if (hasContent){
				jHead.removeClass('hidden');
				jBody.children(':not([data-floor])').removeClass('hidden');
			}
			else{
				jHead.addClass('hidden');
				jBody.children(':not([data-floor])').addClass('hidden');
			}
		});
	}
}

export {
    filter
};
